import API from './common'

export const loginWithToken = async (token) => {
  const response = await API.post('/api/partner/v2/auth/login', {
    login_token: token
  })
  return response.data
}

export const loadLoginProfile = async (accessToken = null) => {
  let response = null

  if(accessToken) {
    response = await API.get('/api/partner/v2/auth/profile', {
      headers: {
        authorization: `Bearer ${accessToken}`
      }
    })
  }
  else {
    response = await API.get('/api/partner/v2/auth/profile')
  }
  
  return response.data
}

export const loginWithUsername = async (username, password) => {
  const result = await API.post('/api/partner/v2/auth/login_legacy', {
    username: username,
    password: password
  })

  return result.data
}

export const getSessionKey = async () => {
  const response = await API.get('/api/partner/v2/auth/profile/update')
  return response.data
}

export default {
  loginWithToken,
  loadLoginProfile,
  loginWithUsername,
  getSessionKey
}


// WEBPACK FOOTER //
// ./src/api/auth.js